const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgNoResult = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#EAEAF3"
    },
    cx: 100,
    cy: 100,
    r: 100
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 100,
    y1: 159.0021,
    x2: 100,
    y2: 33.4004,
    gradientTransform: "matrix(-1 0 0 -1 200 200.2013)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001118171,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4469,
    style: {
      stopColor: "#F9F9FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EAEAF3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M52.317,41.199h95.366c4.593,0,8.317,3.724,8.317,8.317v108.967 c0,4.593-3.724,8.317-8.317,8.317H52.317c-4.593,0-8.317-3.724-8.317-8.317V49.516C44,44.923,47.724,41.199,52.317,41.199z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000052084552600551389420000016959057644389594533_",
    gradientUnits: "userSpaceOnUse",
    x1: 100,
    y1: 67.8658,
    x2: 100,
    y2: 41.1992
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C8CADB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9399B5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000052084552600551389420000016959057644389594533_)"
    },
    d: "M156,67.866H44V49.081 c0-4.353,3.529-7.882,7.882-7.882h96.235c4.353,0,7.882,3.529,7.882,7.882V67.866z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 57.333,
    cy: 54.532,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 69.333,
    cy: 54.532,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 81.333,
    cy: 54.532,
    r: 4
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000022531253087780519540000001527362606111670710_",
    gradientUnits: "userSpaceOnUse",
    x1: 60.6319,
    y1: 128.5499,
    x2: 94,
    y2: 128.5499,
    gradientTransform: "matrix(-1 0 0 1 194 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001118171,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4469,
    style: {
      stopColor: "#F9F9FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EAEAF3"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "url(#SVGID_00000022531253087780519540000001527362606111670710_)",
      stroke: "#B6BACC",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 100,
    y1: 111.866,
    x2: 133.368,
    y2: 145.234
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000129175200866130775890000004355140593317586583_",
    gradientUnits: "userSpaceOnUse",
    x1: 66.8262,
    y1: 100.5409,
    x2: 122.4933,
    y2: 100.5409,
    gradientTransform: "matrix(-0.7071 -0.7071 -0.7071 0.7071 238.028 107.7071)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001118171,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4469,
    style: {
      stopColor: "#F9F9FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EAEAF3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000129175200866130775890000004355140593317586583_)"
    },
    d: "M100,139.699 c-7.435,0-14.424-2.896-19.681-8.152s-8.152-12.246-8.152-19.681c0-7.436,2.896-14.425,8.152-19.682S92.565,84.032,100,84.032 s14.424,2.896,19.682,8.152c10.853,10.853,10.853,28.51,0,39.362C114.424,136.804,107.435,139.699,100,139.699z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969BB7"
    },
    d: "M100,85.533c7.034,0,13.647,2.739,18.62,7.713c10.267,10.267,10.267,26.974,0,37.241 c-4.974,4.974-11.587,7.713-18.62,7.713c-7.034,0-13.647-2.739-18.62-7.713c-10.267-10.267-10.267-26.974,0-37.241 C86.353,88.272,92.966,85.533,100,85.533 M100,82.533c-7.507,0-15.014,2.864-20.742,8.592c-11.455,11.455-11.455,30.028,0,41.484 c5.728,5.728,13.235,8.592,20.742,8.592c7.507,0,15.014-2.864,20.742-8.592c11.455-11.455,11.455-30.028,0-41.484 C115.014,85.396,107.507,82.533,100,82.533L100,82.533z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B6BACC"
    },
    d: "M96.665,114.723c0-5.214,6.595-5.982,6.595-10.39c0-2.377-1.879-4.064-4.64-4.064 c-1.032,0-2.159,0.252-3.552,0.908c-1.216,0.572-2.62-0.3-2.62-1.644v0c0-0.726,0.437-1.383,1.099-1.682 c2.188-0.989,4.012-1.301,5.496-1.301c4.907,0,8.511,3.067,8.511,7.284c0,5.942-7.015,6.977-7.015,10.966v1.08 c0,1.069-0.867,1.936-1.936,1.936h0c-1.069,0-1.936-0.867-1.936-1.936V114.723z M101.147,123.407 c0.119,1.654-1.188,2.887-2.848,2.731c-1.203-0.113-2.226-1.103-2.319-2.309c-0.127-1.644,1.22-2.971,2.869-2.812 C100.067,121.135,101.059,122.186,101.147,123.407z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEAF3"
    },
    d: "M100,90.199c11.947,0,21.667,9.72,21.667,21.667s-9.72,21.667-21.667,21.667 s-21.667-9.72-21.667-21.667S88.053,90.199,100,90.199 M100,89.199c-12.518,0-22.667,10.148-22.667,22.667 S87.482,134.532,100,134.532s22.667-10.148,22.667-22.667S112.518,89.199,100,89.199L100,89.199z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNoResult, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/no-result.ba538acb.svg";
export { ForwardRef as ReactComponent };